import React from 'react'
import CookieConsent, { Cookies } from "react-cookie-consent";

export default function CookiePolicy() {
	return (
		<div>
			<CookieConsent
				location="bottom"
				buttonText="ACCEPT"
				cookieName="gatsby-gdpr-google-tagmanager"
				containerClasses="bg-policy-container h-48 text-base justify-center md:pr-52 md:pl-32 md:h-20 md:justify-between items-center	"
				buttonClasses="bg-yellow text-xs w-20	h-8 font-bold md:text-base md:w-28 md:h-12 "
				expires={150}
			>
				We use cookies to give you the best online experience and to keep our site reliable and secure. Read more about it <a className='underline' target="_blank" href="https://cityrelay.com/cookie-policy/">here</a>.
			</CookieConsent>
		</div>
	)
}